/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { renderToString } from 'react-dom/server';

import ActionCard from 'components/ActionCard';
import Image from 'components/Image';
import SharingPopup from 'components/SharingPopup';

import StorageHandler from 'config/StorageHandler';

import { appContentUrl, baseAppId, storageKeys } from 'settings';

const handleClick = (itemID, email) => {
  const url = `https://travproconnect.com/profile/${itemID}?app_id=${baseAppId}&email=${email}&mobile=true`;
  window.postMessage(`webview:${url}`, '*');
  window.ReactNativeWebView.postMessage(`webview:${url}`, '*');
};

export default class ShowcaseCollectionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
  }

  componentDidMount() {
    // Set user object in state
    this.getUser();
  }

  getUser() {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      if (userObj && userObj.response) {
        ({ email } = userObj.response);
      }
      this.setState({ email });
    });
  }

  render() {
    const { appId, image, subtitle, title, language } = this.props;
    const { email } = this.state;

    let { itemID } = this.props;
    itemID = Number(itemID);

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['close'],
      share: {
        tpl: renderToString(<SharingPopup url="" />),
      },
    };

    let newImage = `${appContentUrl}${appId}/salesCompanion/new_${image}`;
    if (appId > 500) {
      newImage = image;
    }

    let copy = subtitle;
    copy = new DOMParser().parseFromString(copy, 'text/html');
    copy = copy.body.textContent || '';
    if (copy.length > 20) {
      copy = `${copy.substring(0, 90)}...`;
    }

    const params = new URLSearchParams(window.location.search);

    if (params.get('mobile')) {
      return (
        <div className="showcaseCollection__Card">
          <button className="showcaseCollection__Grid--item" onClick={() => {handleClick(itemID, email)}} type="button">
            {/* Dummy image to fool fancybox thumbnails process */}
            <div className="imageContainer">{image && <Image src={newImage} alt={image} gradient={false} />}</div>
            <div id={`${title.toLowerCase().replace(' ', '_')}`} className="textContainer">
              <ActionCard title={title} superTitle={copy} background />
              <div className="showcase">
                <i>{i18n.translate('general.viewItem')} &gt;</i>
              </div>
            </div>
          </button>
        </div>
      );
    }

    return (
      <div className="showcaseCollection__Card">
        <div
          className="showcaseCollection__Grid--item"
          data-src={`https://travproconnect.com/profile/${itemID}?lang=${language}&email=${email}&app_id=${baseAppId}`}
          data-type="iframe"
          data-fancybox={itemID}
          data-options={JSON.stringify(fancyOptions)}
          data-fancybox-trigger={itemID}
        >
          {/* Dummy image to fool fancybox thumbnails process */}
          <div className="imageContainer">{image && <Image src={newImage} alt={image} gradient={false} />}</div>
          <div id={`${title.toLowerCase().replace(' ', '_')}`} className="textContainer">
            <ActionCard title={title} superTitle={copy} background />
            <div className="showcase">
              <i>{i18n.translate('general.viewItem')} &gt;</i>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseCollectionCard.propTypes = {
  appId: PropTypes.number.isRequired,
  image: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  language: PropTypes.string,
  itemID: PropTypes.string.isRequired,
};

ShowcaseCollectionCard.defaultProps = {
  language: 'en',
  image: '',
  subtitle: '',
  title: '',
};
